// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container_2Up1X{position:fixed;top:0;bottom:0;left:0;right:0;background-color:rgba(0,0,0,.7);z-index:999}.closeButton_1AGkJ{position:absolute;top:20px;right:20px;display:flex;align-items:center;justify-content:center;flex-direction:column;width:60px;height:60px;border:none;border-radius:30px;color:#fff;background-color:#000;opacity:.6;cursor:pointer;z-index:1}.closeButton_1AGkJ:hover{color:#000;background-color:#f5f5f5;opacity:.43}.closeButton_1AGkJ .closeIcon_PyaJe{width:24px;height:24px}.contentContainer_2mMPQ{padding-bottom:47.8125%;width:100%;height:0;margin:0 auto;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);overflow:hidden}.content_2e0ZD{position:absolute;top:0;left:0;right:0;bottom:0}.video_11sLE{width:100%;height:100%}.video_11sLE:focus{outline:none}@media(min-width:1024px){.contentContainer_2mMPQ{width:85%}}", ""]);
// Exports
exports.locals = {
	"container": "container_2Up1X",
	"closeButton": "closeButton_1AGkJ",
	"closeIcon": "closeIcon_PyaJe",
	"contentContainer": "contentContainer_2mMPQ",
	"content": "content_2e0ZD",
	"video": "video_11sLE"
};
module.exports = exports;
